(ns manage.content-variant-page.entities.trafficking.view
  (:require ["@mui/icons-material/Error$default" :as ErrorIcon]
            ["@mui/material/Alert$default" :as Alert]
            ["@mui/material/AlertTitle$default" :as AlertTitle]
            ["@mui/material/Button$default" :as Button]
            ["@mui/material/Icon$default" :as Icon]
            ["@mui/material/Stack$default" :as Stack]
            ["@mui/material/Typography$default" :as Typography]
            ["src/svg/objects/book-open.svg$default" :as BookOpen]
            [clojure.set :as set]
            [common.url-template :as url-tpl]
            [re-frame.core :as rf]
            [uix.core :refer [$ defui] :as uix]
            [uix.re-frame :refer [use-subscribe]]))

(defn- export-as-excel-file-section
  [adset-id]
  [:> Stack {:spacing 1}
   [:> Typography {:variant "h4"} "Export tags as excel sheet file"]
   [:> Button {:sx {:align-self "start"}
               :start-icon ($ Icon "cloud_download")
               :on-click (fn [^js _event]
                           (rf/dispatch [:entity/close-view])
                           (rf/dispatch [:export-tags/open-ocp :excel-file [adset-id]]))}
    "Export excel file"]])

(defn- export-as-html-file-section
  [adset-id]
  [:> Stack {:spacing 1}
   [:> Typography {:variant "h4"} "Export tags as HTML file"]
   [:> Button {:sx {:align-self "start"}
               :start-icon ($ Icon "cloud_download")
               :on-click (fn [^js _event]
                           (rf/dispatch [:entity/close-view])
                           (rf/dispatch [:export-tags/open-ocp :html-file [adset-id]]))}
    "Export HTML file"]])

(defn- vast-content
  []
  (let [{:keys [adset-id]} @(rf/subscribe [:url-context])]
    [:> Stack {:spacing 3}
     [export-as-excel-file-section adset-id]
     [export-as-html-file-section adset-id]]))

(defn- display-content []
  (let [{:keys [adset-id]} @(rf/subscribe [:url-context])]
    [:> Stack {:spacing 3}
     [:> Stack {:spacing 1}
      [:> Typography {:variant "h4"} "Export via export wizard"]
      [:> Button {:sx {:align-self "start"}
                  :start-icon ($ Icon "download")
                  :href "#export"}
       "Export to adserver"]]
     [export-as-excel-file-section adset-id]
     [export-as-html-file-section adset-id]]))

(defn- trafficking-content []
  (let [adset-channel @(rf/subscribe [:resource.adset/current-channel])]
    (case adset-channel
      ;; both "Display" and "Display Rules" adsets
      "display" [display-content]

      ;; "Online Video" adsets
      "video" [vast-content]

      ;; "Meta" adsets: don't show
      "meta" nil

      ;; "YouTube" adsets: currently, users are sent to the export app,
      ;; so they don't reach this view.
      "youtube" [vast-content]

      ;; "Connected TV" adsets
      "ctv" [vast-content]

      nil)))

(defn get-missing-templates
  [templates defaults]
  (let [template-dimensions (->> templates (mapv #(select-keys % [:width :height])) set)
        template-dimensions-from-defaults (->> defaults (mapcat :template-dimensions) set)]
    (set/difference template-dimensions template-dimensions-from-defaults)))

(defui warning-component [_]
  (let [url-context (use-subscribe [:url-context])
        defaults (use-subscribe [:resource.content-variants/defaults])
        adset (use-subscribe [:resource.adset/one])
        templates (-> adset :value :templateRevisions)
        show-warning? (< (count defaults) (count templates))
        feed-id (use-subscribe [:resource.adset/current-feed-id])]
    (uix/use-effect (fn []
                      (when feed-id
                        ;; It is done this way to trigger the call every time when ocp opened
                        ;; and avoid calling it with nil feed-id value
                        (rf/dispatch [:resource.content-variants/get-defaults])))
                    [feed-id])
    (when show-warning?
      (let [not-all-assigned? (> (count defaults) 0)
            missing-templates (get-missing-templates templates defaults)
            template-sizes (map #(str (:width %) "x" (:height %)) missing-templates)
            warning-title (if not-all-assigned?
                            "A default is missing for one or more formats in your adset"
                            "A default is missing in your adset")
            warning-text (if not-all-assigned?
                           (str "It looks like a default is not assigned yet to all formats in your adset. A default is required so there is always an ad to show to your audience when no other dynamic variants are eligible. Please assign a default first for the following format"
                                (if (> (count missing-templates) 1) "s" "")
                                ":")
                           "It looks like a default is not assigned yet in your adset. A default is required so there is always an ad to show to your audience when no other dynamic variants are eligible. Please assign a default first.")]
        ($ Alert
           {:severity "info"
            :icon ($ ErrorIcon {:color "primary"})}
           ($ AlertTitle warning-title)
           ($ Stack {:direction "column"
                     :alignItems "flex-start"
                     :gap 1}
              warning-text
              (when not-all-assigned?
                (for [ts template-sizes]
                  ($ Typography (str "  • " ts))))
              ($ Button {:width 180
                         :variant "contained"
                         :href (url-tpl/render :docs/article (assoc url-context :slug "24177224749852-Default-Management-for-Content-Variants"))
                         :target "_blank"
                         :startIcon ($ BookOpen)}
                 "Learn more")))))))

(defn- trafficking-content-wrapper
  []
  [:> Stack {:direction "column" :spacing 3 :p 3}
   ($ warning-component {})
   [trafficking-content]])

(defn entity-cfg [cc]
  {:entity/ref cc
   :entity/icon "swap_vert"
   :entity/label "Trafficking"
   :entity/content [trafficking-content-wrapper]})
